export default {
  createPlan: 'Criar Plano',
  noModelsAvailable: 'Não há modelos disponíveis. Crie o primeiro ou fale com o administrador.',
  search: 'Buscar',
  loading: 'Carregando...',
  noPlansAvailable: 'Não há planos disponíveis para este modelo',
  running: 'Executando...',
  headerName: 'Nome',
  headerBudget: 'Orçamento',
  headerPredictedKpi: '{kpiName} Projetadas',
  headerPeriod: 'Período',
  headerCreated: 'Criado',
  defaultKpiName: 'Vendas',
  defaultCurrency: 'USD',
  sharedWithExternalUsers: 'Compartilhado com usuários externos',
  createFromScratch: 'Do Zero',
  createLastYearActualBudget: 'Ano Anterior, Orçamento Real (Strategy Check)',
  createLastYearActualBudgetWeekly: 'Ano Anterior, Orçamento Real (Strategy Check)',
  createLastYearNoBudget: 'Ano Anterior, Sem Orçamento',
  createNextYearBudgetPropagationMonthly: 'Ano Seguinte, Propagação de Orçamento Real (Forward Looking)',
  createNextYearBudgetPropagationWeekly: 'Ano Seguinte, Propagação de Orçamento Real (Forward Looking)',
  createLastYearOnePulseMonthly: 'Ano Anterior, Um Pulso de investimento em mídia',
  createLastYearOnePulseWeekly: 'Ano Anterior, Um Pulso de investimento em mídia',
  chooseFromScratchDescription: 'Defina você o período e insira o investimento de cada canal.',
  chooseActualBudgetTitle: 'Orçamento Real do Ano Anterior',
  chooseActualBudgetDescription: 'Carrega o investimento real por canal dos últimos 12 meses de dados.',
  chooseNoBudgetTitle: 'Ano Anterior, Sem Orçamento',
  chooseNoBudgetDescription: 'O mesmo período dos últimos 12 meses com todos os canais em zero, pronto para preencher.',
  chooseOnePulseTitle: 'Ano Anterior, Um Pulso',
  chooseOnePulseDescription: 'Um único pulso no nível de saturação de cada canal no primeiro período e depois zero, para ver seu carry-over.',
  chooseNextYearTitle: 'Propagação de Orçamento do Ano Seguinte',
  chooseNextYearDescription: 'Carrega o investimento por canal que o modelo propaga para o próximo ano.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagBlank: 'Em branco',
  chooseTagCarryOver: 'Carry-over',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Datas Flexíveis',
  chooseFlexibleTitle: 'Datas Flexíveis',
  chooseFlexibleDescription: 'Escolha qualquer período: ele é preenchido com o investimento real onde o modelo o tem e com a propagação de orçamento depois.',
  chooseTagFlexible: 'Flexível',
  flexibleSummaryActual: 'Investimento real',
  flexibleSummaryPropagation: 'Propagação de orçamento',
  flexibleSummaryEmpty: 'Sem dados, começa em 0',
  flexibleSummaryTotal: 'Orçamento pré-preenchido',
  flexibleMonths: '{count} mês | {count} meses',
  flexibleWeeks: '{count} semana | {count} semanas',
  flexibleHintActual: 'Há investimento real disponível até {date}.',
  flexibleHintPropagation: 'A propagação de orçamento cobre de {from} a {to}.',
  channelMismatchTitle: 'Os canais do modelo mudaram',
  channelMismatchIntro: 'Os canais de mídia deste modelo não correspondem mais aos deste plano, provavelmente porque o modelo foi atualizado após a criação do plano. Se você continuar, o plano usará os canais atuais do modelo.',
  channelMismatchRemoved: 'Canais do plano que não existem mais no modelo (o investimento deles será descartado):',
  channelMismatchAdded: 'Novos canais do modelo que não estavam no plano (começarão em 0):',
  channelMismatchProceedAnyway: 'Continuar mesmo assim',
  channelMismatchCancel: 'Cancelar'
}
